import { useCallback, useState } from "react";
import { getStores } from "../../../components/stores/functions";

export function useStoresSearch(user) {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const search = useCallback(async () => {
    if (!user?.token) {
      return;
    }

    setLoading(true);
    setError(null);

    const data = await getStores(user.token);

    if (data?.type === "error") {
      setError(data);
      setStores([]);
    } else if (data?.type === "success") {
      setStores(data.data ?? []);
    } else {
      setStores([]);
    }

    setLoading(false);
  }, [user?.token]);

  const refresh = useCallback(() => search(), [search]);

  return { stores, loading, error, search, refresh };
}
